import { render, staticRenderFns } from "./TradeContracts.vue?vue&type=template&id=9fc66d56&scoped=true&"
import script from "./TradeContracts.vue?vue&type=script&lang=js&"
export * from "./TradeContracts.vue?vue&type=script&lang=js&"
import style0 from "./TradeContracts.vue?vue&type=style&index=0&id=9fc66d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc66d56",
  null
  
)

export default component.exports